(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-team"] && !Shopify.designMode) return;
  try {
    
  function initAboutTeamSliders(container) {
    const root = container || document;
    const splideList = root.querySelectorAll('.splide--about-team');
    splideList.forEach(function (el) {
      if (typeof Splide !== 'undefined' && !el.classList.contains('is-initialized')) {
        const splideInstance = new Splide(el, {
          type: 'slide',
          drag: true,
          gap: '1.5rem',
          autoWidth: true,
          snap: true,
          arrows: false,
          pagination: true,
          breakpoints: {
            1023: {
              gap: '1rem',
            },
            639: {
              gap: '0.75rem',
            },
          },
        });
        splideInstance.mount();
        el.classList.add('is-initialized');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAboutTeamSliders();
  });
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAboutTeamSliders();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAboutTeamSliders(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  function initCollectionTabs(root) {
    const scope = root || document;
    const tabsEls = scope.querySelectorAll('.splide--category-tabs');
    tabsEls.forEach(function (tabsEl) {
      if (typeof Splide !== 'undefined' && !tabsEl.classList.contains('is-initialized')) {
        new Splide(tabsEl, {
          type: 'slide',
          drag: 'free',
          gap: '0.5rem',
          autoWidth: true,
          arrows: false,
          pagination: false,
          snap: false,
        }).mount();
      }
    });

    const productSliders = scope.querySelectorAll('.splide--category-products');
    productSliders.forEach(function (el) {
      if (typeof Splide !== 'undefined' && !el.classList.contains('is-initialized')) {
        const gapD = el.getAttribute('data-gap-desktop') || '1rem';
        const gapT = el.getAttribute('data-gap-tablet') || '0.75rem';
        const gapM = el.getAttribute('data-gap-mobile') || '0.5rem';
        const splide = new Splide(el, {
          type: 'slide',
          drag: true,
          gap: gapD,
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: false,
          breakpoints: {
            1023: {
              gap: gapT,
            },
            639: {
              gap: gapM,
            },
          },
        });
        splide.mount();
        el.splideInstance = splide;
      }
    });

    const tabButtons = scope.querySelectorAll('[data-tab-btn]');
    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetTabId = btn.getAttribute('data-tab-target');
        setTimeout(() => {
          const activeSlider = document.querySelector(`.splide--category-products[data-tab-id="${targetTabId}"]`);
          if (activeSlider && activeSlider.splideInstance) {
            activeSlider.splideInstance.refresh();
          }
        }, 50);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollectionTabs(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initCollectionTabs(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  function initFeaturedCollectionSliders(container) {
    const root = container || document;
    const splideFeaturedList = root.querySelectorAll('.splide--featured-collection');
    splideFeaturedList.forEach(function (el) {
      if (typeof Splide !== 'undefined' && !el.classList.contains('is-initialized')) {
        const gapDesktop = el.dataset.gapDesktop || '1rem';
        const gapTablet = el.dataset.gapTablet || '0.75rem';
        const gapMobile = el.dataset.gapMobile || '0.5rem';
        new Splide(el, {
          type: 'slide',
          drag: true,
          gap: gapDesktop,
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: false,
          breakpoints: {
            1023: {
              gap: gapTablet,
            },
            639: {
              gap: gapMobile,
            },
          },
        }).mount();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFeaturedCollectionSliders();
  });
  document.addEventListener('shopify:section:load', function (e) {
    initFeaturedCollectionSliders(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  function initNavCollections(container) {
    const root = container || document;
    const sliders = root.querySelectorAll('.splide--nav-collections');
    sliders.forEach(function (el) {
      if (typeof Splide !== 'undefined' && !el.classList.contains('is-initialized')) {
        const isMobileGrid = el.classList.contains('splide--mobile-grid');
        const gapDesktop = el.dataset.gapDesktop || '1rem';
        const gapTablet = el.dataset.gapTablet || '0.75rem';
        const gapMobile = el.dataset.gapMobile || '0.5rem';
        const splide = new Splide(el, {
          type: 'slide',
          drag: true,
          gap: gapDesktop,
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: false,
          breakpoints: {
            1023: {
              gap: gapTablet,
            },
            639: isMobileGrid ? { destroy: true } : { gap: gapMobile },
          },
        });

        const checkCenterAlign = function () {
          const track = el.querySelector('.splide__track');
          const list = el.querySelector('.splide__list');
          if (track && list) {
            if (list.scrollWidth <= track.clientWidth) {
              list.style.justifyContent = 'center';
            } else {
              list.style.justifyContent = '';
            }
          }
        };

        splide.on('mounted updated resized', checkCenterAlign);
        splide.mount();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNavCollections();
  });
  document.addEventListener('shopify:section:load', function (e) {
    initNavCollections(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  function initRelatedProductsSliders(container) {
    const root = container || document;
    const splideRelatedList = root.querySelectorAll('.splide--related-products');
    splideRelatedList.forEach(function (el) {
      if (typeof Splide !== 'undefined' && !el.classList.contains('is-initialized')) {
        const gapDesktop = el.dataset.gapDesktop || '1rem';
        const gapTablet = el.dataset.gapTablet || '0.75rem';
        const gapMobile = el.dataset.gapMobile || '0.5rem';
        new Splide(el, {
          type: 'slide',
          drag: true,
          gap: gapDesktop,
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: false,
          breakpoints: {
            1023: {
              gap: gapTablet,
            },
            639: {
              gap: gapMobile,
            },
          },
        }).mount();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRelatedProductsSliders();
  });
  document.addEventListener('shopify:section:load', function (e) {
    initRelatedProductsSliders(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-reels"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Helper to update sound toggle button state
    function updateSoundBtn(btn, isMuted) {
      if (!btn) return;
      const iconMuted = btn.querySelector('.icon-muted');
      const iconUnmuted = btn.querySelector('.icon-unmuted');
      if (isMuted) {
        if (iconMuted) iconMuted.classList.remove('hidden');
        if (iconUnmuted) iconUnmuted.classList.add('hidden');
        btn.setAttribute('title', 'Unmute audio');
        btn.setAttribute('aria-label', 'Unmute audio');
      } else {
        if (iconMuted) iconMuted.classList.add('hidden');
        if (iconUnmuted) iconUnmuted.classList.remove('hidden');
        btn.setAttribute('title', 'Mute audio');
        btn.setAttribute('aria-label', 'Mute audio');
      }
    }

    // Helper to update fullscreen button state
    function updateFullscreenBtn(btn, isFullscreen) {
      if (!btn) return;
      const iconMax = btn.querySelector('.icon-maximize');
      const iconMin = btn.querySelector('.icon-minimize');
      if (isFullscreen) {
        if (iconMax) iconMax.classList.add('hidden');
        if (iconMin) iconMin.classList.remove('hidden');
        btn.setAttribute('title', 'Exit full screen');
        btn.setAttribute('aria-label', 'Exit full screen');
      } else {
        if (iconMax) iconMax.classList.remove('hidden');
        if (iconMin) iconMin.classList.add('hidden');
        btn.setAttribute('title', 'Full screen');
        btn.setAttribute('aria-label', 'Full screen');
      }
    }

    // Global audio exclusivity: strictly only one video can play audio across the page
    function muteAllOtherVideos(activeVideo) {
      document.querySelectorAll('.section-shoppable-reels video').forEach(function (otherVid) {
        if (otherVid !== activeVideo && !otherVid.muted) {
          otherVid.muted = true;
          const otherCard = otherVid.closest('[data-reel-card]');
          if (otherCard) {
            const otherBtn = otherCard.querySelector('[data-sound-toggle]');
            if (otherBtn) updateSoundBtn(otherBtn, true);
          }
        }
      });
    }

    // Fallback fullscreen for mobile/browser environments where requestFullscreen is restricted
    function enterFallbackFullscreen(cardEl) {
      if (cardEl.classList.contains('is-fullscreen')) return;

      cardEl._prevParent = cardEl.parentNode;
      cardEl._prevSibling = cardEl.nextSibling;

      const vid = cardEl.querySelector('video');
      const wasPaused = vid ? vid.paused : true;
      const currentTime = vid ? vid.currentTime : 0;
      const wasMuted = vid ? vid.muted : true;

      document.body.appendChild(cardEl);
      cardEl.classList.add('is-fullscreen');
      document.body.classList.add('has-fullscreen-reel');

      if (vid) {
        vid.currentTime = currentTime;
        vid.muted = wasMuted;
        if (!wasPaused) vid.play().catch(function () {});
      }

      const btn = cardEl.querySelector('[data-fullscreen-toggle]');
      if (btn) updateFullscreenBtn(btn, true);
    }

    function exitFallbackFullscreen(cardEl) {
      if (!cardEl.classList.contains('is-fullscreen')) return;

      const vid = cardEl.querySelector('video');
      const wasPaused = vid ? vid.paused : true;
      const currentTime = vid ? vid.currentTime : 0;
      const wasMuted = vid ? vid.muted : true;

      if (cardEl._prevParent) {
        cardEl._prevParent.insertBefore(cardEl, cardEl._prevSibling);
        delete cardEl._prevParent;
        delete cardEl._prevSibling;
      }

      cardEl.classList.remove('is-fullscreen');
      document.body.classList.remove('has-fullscreen-reel');

      if (vid) {
        vid.currentTime = currentTime;
        vid.muted = wasMuted;
        if (!wasPaused) vid.play().catch(function () {});
      }

      const btn = cardEl.querySelector('[data-fullscreen-toggle]');
      if (btn) updateFullscreenBtn(btn, false);
    }

    function initSection(sec) {
      if (sec.dataset.reelsInitialized === 'true') return;
      sec.dataset.reelsInitialized = 'true';

      const splideEl = sec.querySelector('.splide--shoppable-reels');
      if (splideEl && typeof Splide !== 'undefined') {
        new Splide(splideEl, {
          type: 'slide',
          drag: true,
          gap: '1rem',
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: true,
          breakpoints: {
            639: {
              gap: '0.75rem',
            },
          },
        }).mount();
      }

      const reelCards = sec.querySelectorAll('[data-reel-card]');

      reelCards.forEach(function (card) {
        const video = card.querySelector('video');
        const soundBtn = card.querySelector('[data-sound-toggle]');
        const fsBtn = card.querySelector('[data-fullscreen-toggle]');
        const playOverlay = card.querySelector('[data-play-overlay]');
        const playIcon = card.querySelector('[data-play-icon]');
        const scrubber = card.querySelector('[data-scrubber]');
        const productCard = card.querySelector('[data-product-card]');

        // Prevent product card clicks from triggering parent card overlay gestures
        if (productCard) {
          productCard.addEventListener('click', function (e) {
            e.stopPropagation();
          });
        }

        // Fullscreen Toggle (supports both video and cover image reels)
        if (fsBtn) {
          fsBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const isNativeFs = document.fullscreenElement === card || document.webkitFullscreenElement === card;
            const isFallbackFs = card.classList.contains('is-fullscreen');

            if (isNativeFs) {
              if (document.exitFullscreen) {
                document.exitFullscreen().catch(function () {});
              } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
              }
            } else if (isFallbackFs) {
              exitFallbackFullscreen(card);
            } else {
              if (card.requestFullscreen) {
                card.requestFullscreen().catch(function () {
                  enterFallbackFullscreen(card);
                });
              } else if (card.webkitRequestFullscreen) {
                card.webkitRequestFullscreen();
              } else if (video && video.webkitEnterFullscreen) {
                video.webkitEnterFullscreen();
              } else {
                enterFallbackFullscreen(card);
              }
            }
          });
        }

        if (!video) return;

        // Sound Toggle
        if (soundBtn) {
          soundBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const willBeMuted = !video.muted;
            if (!willBeMuted) {
              muteAllOtherVideos(video);
            }
            video.muted = willBeMuted;
            updateSoundBtn(soundBtn, willBeMuted);

            if (!willBeMuted && video.paused) {
              video.play().catch(function () {});
            }
          });
        }

        video.addEventListener('volumechange', function () {
          if (!video.muted) {
            muteAllOtherVideos(video);
            if (soundBtn) updateSoundBtn(soundBtn, false);
          } else {
            if (soundBtn) updateSoundBtn(soundBtn, true);
          }
        });

        video.addEventListener('play', function () {
          if (!video.muted) {
            muteAllOtherVideos(video);
          }
        });

        // Interactive Timeline Scrubber
        let isScrubbing = false;

        if (scrubber) {
          function handleScrub(e) {
            e.stopPropagation();
            if (video.duration && !isNaN(video.duration)) {
              video.currentTime = (parseFloat(scrubber.value) / 100) * video.duration;
            }
          }

          function endScrub(e) {
            if (isScrubbing) {
              if (e) handleScrub(e);
              isScrubbing = false;
            }
          }

          scrubber.addEventListener('mousedown', function (e) {
            e.stopPropagation();
            isScrubbing = true;
          });
          scrubber.addEventListener(
            'touchstart',
            function (e) {
              e.stopPropagation();
              isScrubbing = true;
            },
            { passive: true },
          );
          scrubber.addEventListener('input', handleScrub);
          scrubber.addEventListener('change', endScrub);
          scrubber.addEventListener('mouseup', endScrub);
          scrubber.addEventListener('touchend', endScrub);
          window.addEventListener('mouseup', function () {
            isScrubbing = false;
          });
          window.addEventListener('touchend', function () {
            isScrubbing = false;
          });
        }

        video.addEventListener('timeupdate', function () {
          if (!isScrubbing && video.duration && scrubber && !isNaN(video.duration)) {
            scrubber.value = (video.currentTime / video.duration) * 100;
          }
        });

        // Tap to play / pause
        if (playOverlay) {
          playOverlay.addEventListener('click', function (e) {
            e.stopPropagation();
            if (video.paused) {
              delete card.dataset.userPaused;
              video.play().catch(function () {});
              showPlayIndicator(false);
            } else {
              card.dataset.userPaused = 'true';
              video.pause();
              showPlayIndicator(true);
            }
          });
        }

        function showPlayIndicator(isPaused) {
          if (!playIcon) return;
          const iconPlay = playIcon.querySelector('.icon-play');
          const iconPause = playIcon.querySelector('.icon-pause');
          if (isPaused) {
            if (iconPlay) iconPlay.classList.remove('hidden');
            if (iconPause) iconPause.classList.add('hidden');
            playIcon.classList.remove('opacity-0');
          } else {
            if (iconPlay) iconPlay.classList.add('hidden');
            if (iconPause) iconPause.classList.remove('hidden');
            playIcon.classList.remove('opacity-0');
            setTimeout(function () {
              playIcon.classList.add('opacity-0');
            }, 600);
          }
        }
      });

      // Viewport IntersectionObserver
      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              const cardEl = entry.target;
              const vidEl = cardEl.querySelector('video');
              if (!vidEl) return;

              if (entry.isIntersecting) {
                if (vidEl.paused && !cardEl.dataset.userPaused) {
                  vidEl.play().catch(function () {});
                }
              } else {
                if (!vidEl.paused) {
                  vidEl.pause();
                }
                if (!vidEl.muted) {
                  vidEl.muted = true;
                  const btn = cardEl.querySelector('[data-sound-toggle]');
                  if (btn) updateSoundBtn(btn, true);
                }
              }
            });
          },
          {
            rootMargin: '60px 0px 60px 0px',
            threshold: 0.25,
          },
        );

        reelCards.forEach(function (c) {
          videoObserver.observe(c);
        });
      }
    }

    function setupAllReels() {
      document.querySelectorAll('.section-shoppable-reels').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAllReels);
    } else {
      setupAllReels();
    }

    // Shopify Theme Editor Support
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.classList.contains('section-shoppable-reels')) {
        initSection(e.target);
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      const activeFallback = document.querySelector('[data-reel-card].is-fullscreen');
      if (activeFallback) {
        exitFallbackFullscreen(activeFallback);
      }
    });

    // Native fullscreen change handler
    function handleNativeFullscreenChange() {
      const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      document.querySelectorAll('[data-reel-card]').forEach(function (c) {
        const btn = c.querySelector('[data-fullscreen-toggle]');
        if (!btn) return;
        const isFs = fsEl === c || c.classList.contains('is-fullscreen');
        updateFullscreenBtn(btn, isFs);
      });
    }

    document.addEventListener('fullscreenchange', handleNativeFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleNativeFullscreenChange);

    // Escape key listener for fallback fullscreen
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const activeFallback = document.querySelector('[data-reel-card].is-fullscreen');
        if (activeFallback) {
          exitFallbackFullscreen(activeFallback);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const initSlideshow = (el) => {
      if (typeof Splide === 'undefined') return;

      const autoplay = el.dataset.autoplay === 'true';
      const splide = new Splide(el, {
        type: 'fade',
        rewind: true,
        autoplay: autoplay,
        interval: parseInt(el.dataset.interval) || 5000,
        speed: parseInt(el.dataset.speed) || 800,
        arrows: false,
        pagination: true,
        drag: true,
        keyboard: true,
      }).mount();

      // Pause autoplay and videos when slideshow is off-screen
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const videos = el.querySelectorAll('video');
              if (!entry.isIntersecting) {
                if (autoplay && splide.Components && splide.Components.Autoplay) {
                  splide.Components.Autoplay.pause();
                }
                videos.forEach((video) => video.pause());
              } else {
                if (autoplay && splide.Components && splide.Components.Autoplay) {
                  splide.Components.Autoplay.play();
                }
                videos.forEach((video) => {
                  if (video.hasAttribute('autoplay')) {
                    video.play().catch(() => {});
                  }
                });
              }
            });
          },
          { threshold: 0.1 },
        );
        observer.observe(el);
      }
    };

    // Only initialize elements with the .splide--slideshow class (multi-slide carousels)
    document.querySelectorAll('.splide--slideshow').forEach(initSlideshow);

    // Observe videos in single-slide static banners so they also pause offscreen
    if ('IntersectionObserver' in window) {
      const staticVideoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (!entry.isIntersecting) {
              video.pause();
            } else if (video.hasAttribute('autoplay')) {
              video.play().catch(() => {});
            }
          });
        },
        { threshold: 0.1 },
      );
      document.querySelectorAll('.slideshow-media-video').forEach((v) => staticVideoObserver.observe(v));
    }

    document.addEventListener('shopify:section:load', (e) => {
      const el = e.target.querySelector('.splide--slideshow');
      if (el) initSlideshow(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  function initTestimonialsSplides(root = document) {
    const splideEls = root.querySelectorAll('.splide--testimonials');
    splideEls.forEach(function (el) {
      if (el.splide) return;
      if (typeof Splide !== 'undefined') {
        const gapDesktop = el.dataset.gapDesktop || '1.5rem';
        const gapMobile = el.dataset.gapMobile || '1rem';
        const instance = new Splide(el, {
          type: 'slide',
          drag: true,
          gap: gapDesktop,
          autoWidth: true,
          snap: false,
          arrows: false,
          pagination: true,
          breakpoints: {
            639: {
              gap: gapMobile,
            },
          },
        });
        instance.mount();
      } else {
        setTimeout(() => initTestimonialsSplides(root), 50);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTestimonialsSplides());
  } else {
    initTestimonialsSplides();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initTestimonialsSplides(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-features"] && !Shopify.designMode) return;
  try {
    
  function initUspsSplides(root = document) {
    const splideEls = root.querySelectorAll('.splide--usps');
    splideEls.forEach(function (el) {
      if (el.splide) {
        try {
          el.splide.destroy(true);
        } catch (err) {}
      }
      if (typeof Splide !== 'undefined') {
        const slides = el.querySelectorAll('.splide__slide');
        if (slides.length <= 1) {
          return;
        }
        const autoplay = el.dataset.autoplay === 'true';
        const interval = parseInt(el.dataset.interval, 10) || 4000;
        const instance = new Splide(el, {
          type: 'loop',
          autoplay: autoplay,
          interval: interval,
          pauseOnHover: true,
          pauseOnFocus: true,
          arrows: false,
          pagination: true,
          perPage: 1,
          drag: true,
          speed: 400,
        });
        instance.mount();
        el.splide = instance;
      } else {
        setTimeout(() => initUspsSplides(root), 50);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUspsSplides());
  } else {
    initUspsSplides();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initUspsSplides(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    const splideEl = e.target.querySelector && e.target.querySelector('.splide--usps');
    if (splideEl && splideEl.splide) {
      try {
        splideEl.splide.destroy(true);
      } catch (err) {}
    }
  });

  } catch(e) { console.error(e); }
})();
})();
